import styles from './A_ListItem.module.css';
import cn from 'classnames';

interface A_ListItemProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
  role?: string;
  'aria-selected'?: boolean;
}

export default function A_ListItem({
  label,
  active,
  onClick,
  role = 'option',
  'aria-selected': ariaSelected,
}: A_ListItemProps) {
  return (
    <div
      className={cn(styles.wrapper, { [styles.active]: active })}
      onClick={onClick}
      role={role}
      aria-selected={ariaSelected}
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <span className={cn(styles.label, 'text-p-3')}>{label}</span>
    </div>
  );
}
